import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { RequestTypes } from '../requestTypes'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import {
  DocumentEngineTemplate,
  IDocumentEngineTemplate,
} from '@core/entities/document-engine'
import { documentEngineTemplateKeys } from '../documentEngineTemplateKeys'

const templateTransform = (response: IDocumentEngineTemplate) =>
  DocumentEngineTemplate.new(response)

export const useGetDocumentEngineTemplate = (
  payload: RequestTypes['getDocumentEngineTemplate'],
  options?: UseQueryOptions<
    IDocumentEngineTemplate,
    RequestErrorType,
    DocumentEngineTemplate
  >,
) => {
  return useQuery({
    select: templateTransform,
    ...documentEngineTemplateKeys.byTemplateId(payload),
    ...options,
  })
}
